import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthContext'
import { ProtectedRoute } from '@/auth/ProtectedRoute'
import { useAuth } from '@/auth/useAuth'
import { AppLayout } from '@/layouts/AppLayout'
import { Landing } from '@/pages/Landing'
import { Login } from '@/pages/Login'
import { Register } from '@/pages/Register'
import { Dashboard } from '@/pages/Dashboard'
import { Fleet } from '@/pages/Fleet'
import { Island } from '@/pages/Island'
import { Map } from '@/pages/Map'
import { Tavern } from '@/pages/Tavern'
import { Captain } from '@/pages/Captain'
import { Cabine } from '@/pages/Cabine'
import { Forge } from '@/pages/Forge'
import { Chantier } from '@/pages/Chantier'
import { Negotiations } from '@/pages/Negotiations'
import { Codex } from '@/pages/Codex'
import { Nouveautes } from '@/pages/Nouveautes'
import { Legal } from '@/pages/Legal'
import { Recits } from '@/pages/Recits'
import { Leaderboards } from '@/pages/Leaderboards'
import { PublicCaptain } from '@/pages/PublicCaptain'

/** "/" shows the public landing to guests, the dashboard to logged-in captains. */
function Home() {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center text-ocean-100">Chargement…</div>
  }
  return isAuthenticated ? <Dashboard /> : <Landing />
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/codex" element={<Codex />} />
            <Route path="/nouveautes" element={<Nouveautes />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/" element={<Home />} />
            <Route
              path="/island"
              element={
                <ProtectedRoute>
                  <Island />
                </ProtectedRoute>
              }
            />
            <Route
              path="/fleet"
              element={
                <ProtectedRoute>
                  <Fleet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/map"
              element={
                <ProtectedRoute>
                  <Map />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taverne"
              element={
                <ProtectedRoute>
                  <Tavern />
                </ProtectedRoute>
              }
            />
            <Route path="/quetes" element={<Navigate to="/taverne" replace />} />
            <Route
              path="/capitaine"
              element={
                <ProtectedRoute>
                  <Captain />
                </ProtectedRoute>
              }
            />
            {/* ⚠️ /capitaine/cabine AVANT /capitaine/:pseudo, sinon « cabine » est lu comme un pseudo. */}
            <Route
              path="/capitaine/cabine"
              element={
                <ProtectedRoute>
                  <Cabine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/capitaine/:pseudo"
              element={
                <ProtectedRoute>
                  <PublicCaptain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/classements"
              element={
                <ProtectedRoute>
                  <Leaderboards />
                </ProtectedRoute>
              }
            />
            <Route
              path="/forge"
              element={
                <ProtectedRoute>
                  <Forge />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chantier"
              element={
                <ProtectedRoute>
                  <Chantier />
                </ProtectedRoute>
              }
            />
            <Route
              path="/negociations"
              element={
                <ProtectedRoute>
                  <Negotiations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recits"
              element={
                <ProtectedRoute>
                  <Recits />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
